import styled from "styled-components";
import { colors } from "./colors";

/** The page's white panels; edge to edge on phones. */
const Card = styled.section`
    overflow: hidden;
    border-radius: 12px;
    border: 1px solid ${colors.line};
    background: ${colors.surface};
    @media (max-width: 600px) { border-radius: 0; border-left: none; border-right: none; }
`;

export default Card;

export const Title = styled.h2`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: ${colors.ink};
`;

export const Subtitle = styled.p`
    margin: 2px 0 0;
    font-size: 14px;
    color: ${colors.muted};
`;
